module.exports = __webpack_public_path__ + "static/media/redhat.651b2c89.svg";